module.exports = "/_next/static/images/tile2-9e009ceb15b8b92a54607f229291637b.png";